import { style } from '@vanilla-extract/css';
import { themeVars, nToPx } from '@tundr/theme';

export const sidePanelBackgroundClass = style({
  transform: 'translateZ(0)',
  position: 'fixed',
  inset: 0,
  zIndex: themeVars.zIndex.sidePanel_background,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  display: 'grid',
  placeItems: 'center',
});

export const sidePanelContainerClass = style({
  transform: 'translateZ(0)',
  outline: 'none' + '!important',
  display: 'flex',
  flexDirection: 'column',
  position: 'fixed',
  top: 0,
  right: 0,
  width: '28%',
  minWidth: 450,
  height: '100vh',
  zIndex: themeVars.zIndex.sidePanel,
  backgroundColor: themeVars.colors.neutrals.brown2,
  padding: nToPx(themeVars.space.x6, themeVars.space.x6, themeVars.space.x8),
  border: 'none',
});

export const closeSidePanelButtonClass = style({
  fontSize: themeVars.font.size.iconMd,
  position: 'absolute',
  top: themeVars.space.x8,
  right: themeVars.space.x6,
});
